"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchParamsMapping = void 0;
var use_query_params_1 = require("use-query-params");
var filters_1 = require("../helpers/filters");
exports.SearchParamsMapping = {
    state: {
        type: use_query_params_1.ArrayParam,
    },
    district: {
        type: use_query_params_1.ArrayParam,
    },
    property_type: {
        type: use_query_params_1.ArrayParam,
    },
    structure_type: {
        type: use_query_params_1.ArrayParam,
    },
    rooms: {
        type: use_query_params_1.ArrayParam,
    },
    price: {
        type: use_query_params_1.ArrayParam,
    },
    monthly_mortgage: {
        type: use_query_params_1.ArrayParam,
    },
    area: {
        type: use_query_params_1.ArrayParam,
    },
    heating: {
        type: use_query_params_1.ArrayParam,
    },
    furniture: {
        type: use_query_params_1.ArrayParam,
    },
    amenities: {
        type: use_query_params_1.ArrayParam,
    },
    bedrooms: {
        type: use_query_params_1.ArrayParam,
    },
    floor: {
        type: use_query_params_1.ArrayParam,
    },
    has_3D_tour: {
        type: use_query_params_1.ArrayParam,
    },
    building_name: {
        type: use_query_params_1.StringParam,
    },
    with_installment: {
        type: use_query_params_1.ArrayParam,
    },
    sortBy: {
        type: use_query_params_1.StringParam,
    },
    zoom: {
        type: use_query_params_1.NumberParam,
    },
    viewBox: {
        type: use_query_params_1.ObjectParam,
    },
    customViewBox: {
        type: filters_1.GeometryArrayParam,
    },
    address: {
        type: use_query_params_1.ObjectParam,
    },
    page: {
        type: use_query_params_1.NumberParam,
    },
};
